<template>
  <div class="app-sales-reports-send-to-email-button">
    <AppSalesReportSendToEmailModal
      v-model="isSendToEmailModalOpen"
      :title="title"
      @send-to-email="sendToEmail"
    />

    <ElButton
      :loading="loading"
      type="primary"
      @click="openModal('isSendToEmailModalOpen')"
    >
      <i class="material-icons">
        email
      </i>
      <span>{{ title }}</span>
    </ElButton>
  </div>
</template>

<script>
import modal from '@/mixins/modal';

import AppSalesReportSendToEmailModal from './AppSalesReportSendToEmailModal';

export default {
  name: 'AppSalesReportsSendToEmailButton',

  components: {
    AppSalesReportSendToEmailModal,
  },

  mixins: [modal],

  props: {
    title: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      isSendToEmailModalOpen: false,
    };
  },

  methods: {
    sendToEmail(email) {
      this.$emit('sendToEmail', email);
    },
  },
};
</script>

<style lang="scss">
.app-sales-reports-send-to-email-button {
  display: inline-block;
}
</style>
